import { render, staticRenderFns } from "./Testquery.vue?vue&type=template&id=554cf117&scoped=true"
import script from "./Testquery.vue?vue&type=script&lang=js"
export * from "./Testquery.vue?vue&type=script&lang=js"
import style0 from "./Testquery.vue?vue&type=style&index=0&id=554cf117&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554cf117",
  null
  
)

export default component.exports